import { isBrowser } from '../ssr';

class Storage {
  getItem() {}
  setItem() {}
  removeItem() {}
}

class Persistor {
  constructor(storage = new Storage(), key = 'cache-persist') {
    this.storage = storage;
    this.key = key;
  }

  get store() {
    const store = this.storage.getItem(this.key);

    return typeof store === 'string' ? JSON.parse(this.storage.getItem(this.key)) : store || {};
  }

  persist(key, values) {
    const store = this.store;
    this.storage.setItem(this.key, JSON.stringify({ ...store, [key]: values }));
  }

  get(key) {
    const store = this.store;

    return store[key];
  }

  purge() {
    this.storage.removeItem(this.key);
  }
}

let persistor = new Persistor();
if (isBrowser) {
  persistor = new Persistor(window.localStorage);
}

export default persistor;
